import { render, staticRenderFns } from "./order-receipt.vue?vue&type=template&id=64fc6822"
import script from "./order-receipt.vue?vue&type=script&lang=js"
export * from "./order-receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports